// Dependencies
import { all, call, takeEvery, fork, put } from "@redux-saga/core/effects";
import moment from 'moment';

// Action Types
import {
    TRANSACTIONS_RESULT_REQUEST
} from 'Redux/actionTypes';

// Actions
import {
    transactionsResultResult,
} from 'Redux/actions';

// Helpers
import { clientQuery } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';

function* transactionsResultsSearch({ payload }) {

    try {
        const { transactionid, dateRange, opensearch, nextToken } = payload;
        let DateFrom = null, DateTo = null;
        let currentdata = [];
        let queryParams = {};

        const TRANSACTIONS_RESULTS = `
                query($searchBy: enumTransactionSearchBy!, $transactionId: String, $status: String, $type: String, $dateRange: AWSDateTimeRange, $limit: Int, $nextToken: String){
                    Transactions: searchTransactions (searchBy: $searchBy, transactionId: $transactionId, status: $status, type: $type, dateRange: $dateRange, limit: $limit, nextToken: $nextToken){
                        nextToken
                        items{
                            TransactionId
                            Type
                            Data
                            Status
                            Message
                            CreatedOn
                            CreatedBy
                        }
                    }
                }    
            `;


        if (opensearch.length > 0) {
            queryParams = {
                searchBy: "TransactionId",
                transactionId: opensearch[0],
                limit: 50,
                nextToken: nextToken,
            }
        } else {
            DateFrom = moment(moment(dateRange.start).format("YYYY-MM-DD") + " 00:00:00").utc().format("YYYY-MM-DDTHH:mm:ss.sss") + "Z";
            DateTo = moment(moment(dateRange.end).format("YYYY-MM-DD") + " 23:59:59").utc().format("YYYY-MM-DDTHH:mm:ss.sss") + "Z";
            queryParams = {
                searchBy: "TypeCreatedOn",
                dateRange: { start: DateFrom, end: DateTo },
                limit: 50,
                nextToken: nextToken
            }
        }

        let data = yield call(
            clientQuery,
            TRANSACTIONS_RESULTS,
            queryParams,
            endpoints.GRAPHQL_GENERAL,
        );

        let result = [];
        let nxtToken = null;
        //To map the main items that comes in the Data as a json
        if (data) {
            currentdata = data?.Transactions || { nextToken: null, items: [] };
            nxtToken = data?.Transactions?.nextToken
            currentdata?.items instanceof Array && currentdata?.items?.map(item => {
                result.push({
                    ...item,
                    Data: JSON.parse(item.Data),
                })
            })
        }
        yield put(transactionsResultResult({ transactions: currentdata?.items, nextToken: nxtToken, oldNextToken: nextToken }));
    } catch (exc) {
        yield put(transactionsResultResult({ error: exc }));

        ExceptionManager(exc,
            "Modules/transactions/views/results/redux/saga/",
            "transactionsResultsSearch")
    }
}


function* watchMethods() {
    yield takeEvery(TRANSACTIONS_RESULT_REQUEST, transactionsResultsSearch);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}